import React from 'react';

const TermsOfService: React.FC = () => (
  <div className="min-h-screen bg-gray-50 py-12" dir="ltr">
    <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
      <p className="text-gray-700 mb-4">By using Vajak, you agree to these Terms of Service. Please read them carefully.</p>
      <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-2">Use of Service</h2>
      <p className="text-gray-700 mb-4">You may use Vajak for personal, non-commercial purposes. Do not misuse our services or attempt to disrupt our platform.</p>
      <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-2">User Content</h2>
      <p className="text-gray-700 mb-4">You are responsible for any content you post. Do not post unlawful, harmful, or offensive material.</p>
      <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-2">Limitation of Liability</h2>
      <p className="text-gray-700 mb-4">Vajak is provided "as is" without warranties. We are not liable for any damages resulting from your use of the platform.</p>
      <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-2">Changes to Terms</h2>
      <p className="text-gray-700 mb-4">We may update these Terms of Service at any time. Continued use of Vajak means you accept the new terms.</p>
      <p className="text-gray-600 mt-8">Last updated: July 2025</p>
    </div>
  </div>
);

export default TermsOfService; 